var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenRoundTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#B4FFBB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4688 18.75L9.90625 15.1875L10.7969 14.2969L13.4688 16.9688L19.2031 11.2344L20.0938 12.125L13.4688 18.75Z",
    fill: "#039511"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenRoundTick);
export default __webpack_public_path__ + "static/media/greenRoundTick.b8f823577aefa8e26ee8cec79820c296.svg";
export { ForwardRef as ReactComponent };